import { type ImportColumn, IMPORT_ROLE_LABELS, type ImportRole } from '@shared/table-import';

const ROLES = Object.keys(IMPORT_ROLE_LABELS) as ImportRole[];

/** The first rows of a table with what each column is, changeable (« Ignorer » leaves a column out). */
export const ImportPreviewTable = ({ headers, rows, mapping, onMapping }: {
  headers: string[];
  rows: string[][];
  mapping: ImportColumn[];
  onMapping: (mapping: ImportColumn[]) => void;
}) => (
  <div className="space-y-2">
    <div className="overflow-x-auto rounded-xl border border-domino-cardBorder">
      <table className="min-w-full text-left text-xs">
        <thead className="bg-domino-warm">
          <tr>
            {headers.map((header, index) => (
              <th key={index} className="px-2 py-2 align-top font-medium text-domino-inkSoft">
                <p className="mb-1 truncate">{header || `Colonne ${index + 1}`}</p>
                <select value={mapping[index]?.as ?? 'parameter'} aria-label={`Ce qu’est « ${header} »`}
                  onChange={(event) => onMapping(mapping.map((column, at) => at === index ? { ...column, as: event.target.value as ImportRole } : column))}
                  className="rounded-md border border-domino-cardBorder bg-domino-white px-1.5 py-1 text-xs text-domino-ink">
                  {ROLES.map((role) => <option key={role} value={role}>{IMPORT_ROLE_LABELS[role]}</option>)}
                </select>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.slice(0, 5).map((row, rowIndex) => (
            <tr key={rowIndex} className="border-t border-domino-cardBorder">
              {headers.map((_, index) => (
                <td key={index} className={`max-w-[12rem] truncate px-2 py-1.5 ${mapping[index]?.as === 'ignore' ? 'text-domino-inkSoft line-through' : 'text-domino-ink'}`}>{row[index] ?? ''}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    {rows.length > 5 && <p className="text-xs text-domino-inkSoft">{rows.length - 5} autre(s) ligne(s)</p>}
  </div>
);
